import Vue from 'vue'
// import AES from 'crypto-js/aes'
Vue.http.interceptors.push((request, next) => {
  // modify request
  // let m = request.method
  // let s
  // if (m === 'GET') {
  //   s = JSON.stringify(request.params)
  // } else {
  //   s = JSON.stringify(request.body)
  // }
  // let args = AES.encrypt(s, 'secret key 123').toString()
  // if (m === 'GET') {
  //   request.params.args = args
  // } else {
  //   request.body.args = args
  // }
  // continue to next interceptor
  next((res) => {
    if (res.status === 401) {
      window.location.hash = "#/auth/login"
    } else {
      return res
    }
  })
})



// WEBPACK FOOTER //
// ./src/resource/interceptor.js